function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import isAbsent from './util/isAbsent';
import isSchema from './util/isSchema';
import printValue from './util/printValue';
import { array as locale } from './locale';
import runTests from './util/runTests';
import ValidationError from './ValidationError';
import BaseSchema from './schema';
export function create(type) {
  return new ArraySchema(type);
}

var ArraySchema = /*#__PURE__*/function (_BaseSchema) {
  _inherits(ArraySchema, _BaseSchema);

  var _super = _createSuper(ArraySchema);

  function ArraySchema(type) {
    var _this;

    _classCallCheck(this, ArraySchema);

    _this = _super.call(this, {
      type: 'array'
    }); // `undefined` specifically means uninitialized, as opposed to
    // "no subtype"

    _this.innerType = void 0;
    _this.innerType = type;

    _this.withMutation(function () {
      _this.transform(function (values) {
        if (typeof values === 'string') try {
          values = JSON.parse(values);
        } catch (err) {
          values = null;
        }
        return this.isType(values) ? values : null;
      });
    });

    return _this;
  }

  _createClass(ArraySchema, [{
    key: "_typeCheck",
    value: function _typeCheck(v) {
      return Array.isArray(v);
    }
  }, {
    key: "_subType",
    get: function get() {
      return this.innerType;
    }
  }, {
    key: "_cast",
    value: function _cast(_value, _opts) {
      var _this2 = this;

      var value = _get(_getPrototypeOf(ArraySchema.prototype), "_cast", this).call(this, _value, _opts); //should ignore nulls here


      if (!this._typeCheck(value) || !this.innerType) return value;
      var isChanged = false;
      var castArray = value.map(function (v, idx) {
        var castElement = _this2.innerType.cast(v, _extends({}, _opts, {
          path: "".concat(_opts.path || '', "[").concat(idx, "]")
        }));

        if (castElement !== v) {
          isChanged = true;
        }

        return castElement;
      });
      return isChanged ? castArray : value;
    }
  }, {
    key: "_validate",
    value: function _validate(_value) {
      var _this3 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var callback = arguments.length > 2 ? arguments[2] : undefined;

      var _options$abortEarly, _options$recursive;

      var errors = [];
      var sync = options.sync;
      var path = options.path;
      var innerType = this.innerType;
      var endEarly = (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly;
      var recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
      var originalValue = options.originalValue != null ? options.originalValue : _value;

      _get(_getPrototypeOf(ArraySchema.prototype), "_validate", this).call(this, _value, options, function (err, value) {
        if (err) {
          if (!ValidationError.isError(err) || endEarly) {
            return void callback(err, value);
          }

          errors.push(err);
        }

        if (!recursive || !innerType || !_this3._typeCheck(value)) {
          callback(errors[0] || null, value);
          return;
        }

        originalValue = originalValue || value; // #950 Ensure that sparse array empty slots are validated

        var tests = new Array(value.length);

        var _loop = function _loop(idx) {
          var item = value[idx];
          var path = "".concat(options.path || '', "[").concat(idx, "]"); // object._validate note for isStrict explanation

          var innerOptions = _extends({}, options, {
            path: path,
            strict: true,
            parent: value,
            index: idx,
            originalValue: originalValue[idx]
          });

          tests[idx] = function (_, cb) {
            return innerType.validate(item, innerOptions, cb);
          };
        };

        for (var idx = 0; idx < value.length; idx++) {
          _loop(idx);
        }

        runTests({
          sync: sync,
          path: path,
          value: value,
          errors: errors,
          endEarly: endEarly,
          tests: tests
        }, callback);
      });
    }
  }, {
    key: "clone",
    value: function clone(spec) {
      var next = _get(_getPrototypeOf(ArraySchema.prototype), "clone", this).call(this, spec);

      next.innerType = this.innerType;
      return next;
    }
  }, {
    key: "concat",
    value: function concat(schema) {
      var next = _get(_getPrototypeOf(ArraySchema.prototype), "concat", this).call(this, schema);

      next.innerType = this.innerType;
      if (schema.innerType) next.innerType = next.innerType ? // @ts-expect-error Lazy doesn't have concat()
      next.innerType.concat(schema.innerType) : schema.innerType;
      return next;
    }
  }, {
    key: "of",
    value: function of(schema) {
      // FIXME: this should return a new instance of array without the default to be
      var next = this.clone();
      if (!isSchema(schema)) throw new TypeError('`array.of()` sub-schema must be a valid yup schema not: ' + printValue(schema)); // FIXME(ts):

      next.innerType = schema;
      return next;
    }
  }, {
    key: "length",
    value: function length(_length) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : locale.length;
      return this.test({
        message: message,
        name: 'length',
        exclusive: true,
        params: {
          length: _length
        },
        test: function test(value) {
          return isAbsent(value) || value.length === this.resolve(_length);
        }
      });
    }
  }, {
    key: "min",
    value: function min(_min, message) {
      message = message || locale.min;
      return this.test({
        message: message,
        name: 'min',
        exclusive: true,
        params: {
          min: _min
        },
        // FIXME(ts): Array<typeof T>
        test: function test(value) {
          return isAbsent(value) || value.length >= this.resolve(_min);
        }
      });
    }
  }, {
    key: "max",
    value: function max(_max, message) {
      message = message || locale.max;
      return this.test({
        message: message,
        name: 'max',
        exclusive: true,
        params: {
          max: _max
        },
        test: function test(value) {
          return isAbsent(value) || value.length <= this.resolve(_max);
        }
      });
    }
  }, {
    key: "ensure",
    value: function ensure() {
      var _this4 = this;

      return this.default(function () {
        return [];
      }).transform(function (val, original) {
        // We don't want to return `null` for nullable schema
        if (_this4._typeCheck(val)) return val;
        return original == null ? [] : [].concat(original);
      });
    }
  }, {
    key: "compact",
    value: function compact(rejector) {
      var reject = !rejector ? function (v) {
        return !!v;
      } : function (v, i, a) {
        return !rejector(v, i, a);
      };
      return this.transform(function (values) {
        return values != null ? values.filter(reject) : values;
      });
    }
  }, {
    key: "describe",
    value: function describe() {
      var base = _get(_getPrototypeOf(ArraySchema.prototype), "describe", this).call(this);

      if (this.innerType) base.innerType = this.innerType.describe();
      return base;
    }
  }, {
    key: "nullable",
    value: function nullable() {
      var isNullable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return _get(_getPrototypeOf(ArraySchema.prototype), "nullable", this).call(this, isNullable);
    }
  }, {
    key: "defined",
    value: function defined() {
      return _get(_getPrototypeOf(ArraySchema.prototype), "defined", this).call(this);
    }
  }, {
    key: "required",
    value: function required(msg) {
      return _get(_getPrototypeOf(ArraySchema.prototype), "required", this).call(this, msg);
    }
  }]);

  return ArraySchema;
}(BaseSchema);

export { ArraySchema as default };
create.prototype = ArraySchema.prototype; //
// Interfaces
//